(function (rapidTappingView, $) {
  var devicesImg;

  rapidTappingView.init = function () {
    devicesImg = $(".rapid-tapping__devices");
    el.Utils.preloadImage("/img/rapid-tapping-el-website-1.png");
    el.Utils.preloadImage("/img/rapid-tapping-el-website-2.png");
    el.Utils.preloadImage("/img/rapid-tapping-el-website-3.png");

    setTimeout(function () {
      startTextAnimation();
    }, 2000);

    wireEvents();
  };

  function startTextAnimation() {
    var rtTextSlideOffset = 1;
    var rtTextSlides = $(".rt__text-slide");
    var rtTextSlideAnimations = [];
    $.each(rtTextSlides, function (index) {
      var animation = new Textify(
        {
          el: "#rt__text-slide-" + index,
          Observer: { repeat: false, threshold: 0.7 },
          animation: { duration: 0.6, stagger: 0.02, ease: "easeOutExpo" },
        },
        gsap,
      );
      // animation.reset();
      rtTextSlideAnimations.push(animation);
    });

    $(rtTextSlides[1]).css("display", "none");
    $(rtTextSlides[0]).css("display", "block");

    var performNextAnimation = function () {
      var prevIndex = (rtTextSlideOffset + 1) % rtTextSlides.length;
      var nextIndex = rtTextSlideOffset % rtTextSlides.length;
      var prevAnimation = rtTextSlideAnimations[prevIndex];
      var nextAnimation = rtTextSlideAnimations[nextIndex];

      prevAnimation.animateOut();

      requestTimeout(function () {
        $(rtTextSlides[prevIndex]).css("display", "none");
        $(rtTextSlides[nextIndex]).css("display", "block");

        // nextAnimation.reset();
        nextAnimation.animateIn();

        requestTimeout(function () {
          cycleDeviceImages();

          requestTimeout(function () {
            performNextAnimation();
            rtTextSlideOffset++;
          }, 3000);
        }, 1600);
      }, 1200);
    };

    performNextAnimation();
  }

  function cycleDeviceImages() {
    var pathPrefix = "/img/";
    devicesImg.attr("src", pathPrefix + "rapid-tapping-el-website-1.png");
    requestTimeout(function () {
      devicesImg.attr("src", pathPrefix + "rapid-tapping-el-website-2.png");
      requestTimeout(function () {
        devicesImg.attr("src", pathPrefix + "rapid-tapping-el-website-3.png");
        requestTimeout(function () {
          devicesImg.attr("src", pathPrefix + "rapid-tapping-el-website.png");
        }, 250);
      }, 250);
    }, 250);
  }

  function wireEvents() {}
})((window.el.RapidTappingView = window.el.RapidTappingView || {}), jQuery);
